import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { debounce } from 'throttle-debounce';

import FloatingInput from './textField'

class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue? props.defaultValue.name: '',
      isOpen: false,
      loading: true,
      navigate: -1,
      openOnFocus: true,
      selectedItemId: ''
    };
    this.debounceOnChange = debounce(this.props.debounceLimit, this.debounceOnChange);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.defaultValue !== nextProps.defaultValue
      && nextProps.defaultValue
      && !this.state.value
    ) {
      this.setState({ value: nextProps.defaultValue.name });
    }
    if(this.props.listData !== nextProps.listData) {
      this.setState({ loading: false })
    }
  }

  componentDidMount() {
    /*if(this.props.originCheck && this.props.originCheck.openOriginDropdown && this.props.fieldName === 'from') {
      this.setState({ value: this.props.originCheck.origin });
      this.debounceOnChange(this.props.originCheck.origin);
      this.openAutocomplete(true);
    }
    if(this.props.destinationCheck && this.props.destinationCheck.openDestDropdown && this.props.fieldName === 'to') {
      this.setState({ value: this.props.destinationCheck.destination });
      this.debounceOnChange(this.props.destinationCheck.destination);
      this.openAutocomplete(true);
    }*/
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.defaultValue && this.props.defaultValue && prevProps.defaultValue.name !== this.props.defaultValue.name
    ) {
      this.setState({
        value: this.props.defaultValue ? this.props.defaultValue.name : '',
      });
    }
  }

  componentWillUpdate(nextProps, { isOpen }) {
    // whenever user opens autocomplete bind event listener
    const prevIsOpen = this.state.isOpen;
    if (prevIsOpen && !isOpen) {
      window.removeEventListener('mousedown', this.pageClick, false);
    } else if (!prevIsOpen && isOpen) {
      window.addEventListener('mousedown', this.pageClick, false);
    }
  }

  pageClick = () => {
    const { isOpen } = this.state;
    // const { page } = this.props;
    // const originValue = (this.props.fieldName === 'from') ? this.props.value : '';
    // const destinationValue = (this.props.fieldName === 'to') ? this.props.value : '';
    if (this.mouseIsDownOnAutocomplete) {
      return;
    }
    if(isOpen) {
      this.openAutocomplete(false);
    }
  }

  mouseDownHandler = () => {
    this.mouseIsDownOnAutocomplete = true;
  }

  mouseUpHandler = () => {
    this.mouseIsDownOnAutocomplete = false;
  }

  debounceOnChange = (value) => {
    if(value) {
      this.props.onChange(value, this.props.fieldName);
    }
  }

  onInputChange = (value) => {
    this.setState({ value, loading: !!value });
    this.debounceOnChange(value);
    this.openAutocomplete(true);
    if(!value && this.props.onClear) {
      this.props.onClear();
    }
  }

  onInputFocus = () => {
    // const { value } = this.state;
    // let openOnFocus = this.state.openOnFocus || !value;
    if(this.props.listData && this.props.listData.length)
      this.setState({ isOpen: true, loading: false })
  }

  onSelection = (item) => {
    this.openAutocomplete(false);
    this.setState({
      value: item.selected_text? item.selected_text : (item.heading_text || ''),
      selectedItem: item,
    }, () => this.props.onSelect(item));
  }

  openAutocomplete = (isOpen = true) => {
    this.setState({ isOpen });
  }

  onInputClear = () => {
    this.setState({ value: '', isOpen: true, selectedItemId: '' });
  }

  getItemsList = () => {
    const { listData } = this.props;
    return listData;
  }

  handleKeyEvent = (e) => {
    const { value, navigate } = this.state;
    const itemsList = this.getItemsList();
    switch (e.key) {
      case 'Escape':
        this.setState({ isOpen: false });
        break;
      case 'ArrowUp':
        this.setState({ navigate: navigate + 1 });
        break;
      case 'ArrowDown':
        this.setState({ navigate: navigate - 1 });
        break;
      case 'Tab':
        if (itemsList.length > 0 && value.length === 0) {
          this.onSelection(itemsList[0]);
        }
        break;
      default:
    }
  }

  renderItems = () => {
    const { /*navigate, value*/ isOpen, loading } = this.state;
    const {
      // limit,
      // customStyle,
      // popularItems,
      // recentHeading,
      // popularHeading
      citiesHeading,
    } = this.props;

    const listItems = this.getItemsList();
    const error = (!listItems || !listItems.length)? <div className="autocomplete-li empty">{this.props.emptyMessage}</div>: null;
    if(/*value && */isOpen) {
      return (
        <div className={'resultContainer customWidth'}>
          <div className='resultsList'>
            {citiesHeading &&
              <div className='recentHeading'>
                {citiesHeading}
              </div>
            }
            {loading? 'Fetching...': (error || this.renderSections(listItems))}
          </div>
        </div>
      );
    }

    return undefined;
  }

  renderSections = (items, offset = 0) => {
    const navigate = this.state;
    return items && items.map((item, _index) => {
      return (
        <div
          key={_index}
          className={`result${navigate === (_index + offset)? ' selected': ''}`}
          onClick={() => this.onSelection(item)}
        >
          {this.props.renderElements(item, this.state.value, navigate === (_index + offset))}
        </div>
      );
    })
  }

  render() {
    const { keyboard, placeholder, loading, withClear, isDisabled, shouldHideCrossIcon=false, compData=false } = this.props;
    return (
      <div
        className='wrapper'
        onMouseDown={this.mouseDownHandler}
        onMouseUp={this.mouseUpHandler}
        onKeyDown={keyboard && this.handleKeyEvent}
      >
        <FloatingInput
          placeholder={placeholder}
          value={this.state.value}
          onChange={this.onInputChange}
          onFocus={this.onInputFocus}
          withClear={withClear}
          onClear={this.onInputClear}
          disabled={isDisabled}
          shouldHideCrossIcon={shouldHideCrossIcon}
          dealListPresent={this.props.dealListPresent}
          compData={compData}
        />
        {
          this.state.isOpen &&
            <div>
              {this.renderItems()}
              { loading ?
                <div className='loadingIcon'><div className='loader' /></div>
                : undefined
              }
            </div>
        }
      </div>
    );
  }
}

Autocomplete.propTypes = {
  listData: PropTypes.array,
  // is fired when input changes
  onChange: PropTypes.func,
  // is fired when any item is selected
  onSelect: PropTypes.func,
  debounceLimit: PropTypes.number,
  placeholder: PropTypes.string,
  // toggles keyboard support
  keyboard: PropTypes.bool,
  citiesHeading: PropTypes.string,
  popularHeading: PropTypes.string,
  recentHeading: PropTypes.string,
  renderElements: PropTypes.oneOfType([
    PropTypes.element, PropTypes.func,
  ]).isRequired,
  // message to be displayed when there is no result
  emptyMessage: PropTypes.string,
  // cross icon with input to clear the input value
  withClear: PropTypes.bool,
  limit: PropTypes.number,
};

// Default proptypes for autocomplete ( current settings supports flights out of the box)
Autocomplete.defaultProps = {
  keyboard: true,
  errorMsg: 'No Matches Found',
  citiesHeading: 'Suggested Cities',
  popularHeading: 'Popular cities',
  recentHeading: 'Recent Searches',
  emptyMessage: 'No Matches Found',
  debounceLimit: 300,
  withClear: true,
  limit: 5,
  customWidth: '',
  returnFocusAfterClear: false,
  openOnFocus: false
};

export default Autocomplete;
